module.exports = __webpack_public_path__ + "img/avatar-22.db37a57b.png";